<div class="space-y-6">
  <!-- Header Section -->
  <div class="flex items-center justify-between bg-card p-6 rounded-xl border border-border shadow-sm">
    <div class="flex items-center space-x-4">
      <div class="p-3 bg-primary/5 rounded-lg text-primary">
        <i class="fas fa-layer-group text-xl"></i>
      </div>
      <div>
        <h3 class="text-lg font-bold text-foreground">Opciones de Cuotas</h3>
        <p class="text-sm text-muted-foreground">Configura los plazos de pago disponibles para este plan.</p>
      </div>
    </div>
    <button type="button" (click)="openAddModal()"
      class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-lg shadow-sm text-primary-foreground bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring transition-all transform hover:scale-105 active:scale-95">
      <i class="fas fa-plus mr-2"></i>
      Agregar Plazo
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="paymentTerms.length === 0"
    class="text-center py-16 bg-muted/40 rounded-xl border-2 border-dashed border-border">
    <div class="w-20 h-20 mx-auto bg-card rounded-full flex items-center justify-center shadow-sm mb-4">
      <i class="fas fa-calendar-plus text-muted-foreground text-4xl"></i>
    </div>
    <h4 class="text-lg font-medium text-foreground mb-1">No hay plazos configurados</h4>
    <p class="text-muted-foreground mb-6 max-w-sm mx-auto">Agrega opciones de cuotas para que tus clientes puedan elegir cómo
      pagar.</p>
    <button type="button" (click)="openAddModal()"
      class="text-primary hover:text-primary font-semibold hover:underline">
      Comenzar ahora &rarr;
    </button>
  </div>

  <!-- List of Terms -->
  <div *ngIf="paymentTerms.length > 0" class="grid gap-3 terms-list pr-2">
    <div *ngFor="let term of paymentTerms; let i = index"
      class="group flex items-center justify-between p-4 bg-card border-2 border-border rounded-lg hover:border-primary hover:shadow-sm transition-all duration-200">

      <div class="flex items-center space-x-4 flex-1">
        <!-- Order Badge -->
        <div
          class="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-full text-primary font-bold text-sm">
          {{ term.order }}
        </div>

        <!-- Info Principal -->
        <div class="flex-1">
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-foreground">{{ term.installments }}</span>
            <span class="text-sm font-semibold text-muted-foreground uppercase">{{ term.installments === 1 ? 'Cuota' : 'Cuotas' }}</span>
            <span class="text-muted-foreground mx-2">•</span>
            <span class="text-base font-medium text-primary">{{ getFrequencyLabel(term) }}</span>
          </div>
        </div>
      </div>

      <!-- Action Button (Solo Eliminar) -->
      <button type="button" (click)="deleteTerm(i)"
        class="p-2 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded-lg transition-colors group-hover:opacity-100 opacity-60"
        title="Eliminar">
        <i class="fas fa-trash-alt text-lg"></i>
      </button>
    </div>
  </div>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
  aria-modal="true">
  <!-- Overlay -->
  <div class="flex items-center justify-center min-h-screen px-4 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-foreground/50 backdrop-blur-md transition-opacity" (click)="closeModal()"
      aria-hidden="true"></div>

    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!-- Modal Panel -->
    <div
      class="modal-panel inline-block align-bottom bg-card rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl w-full border border-border">

      <!-- Modal Header -->
      <div class="bg-card px-6 py-5 border-b border-border flex justify-between items-center">
        <div>
          <h3 class="text-xl font-bold text-foreground" id="modal-title">
            Agregar Plazo
          </h3>
          <p class="text-sm text-muted-foreground mt-1">Define las condiciones de pago para esta opción.</p>
        </div>
        <button (click)="closeModal()"
          class="text-muted-foreground hover:text-foreground hover:bg-accent p-2 rounded-full transition-colors">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <div class="px-6 py-6 bg-muted/30">
        <form [formGroup]="termForm" class="space-y-6">

          <!-- Top Row: Installments & Order -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <!-- Installments -->
            <div>
              <label class="block text-sm font-semibold text-foreground mb-2">Número de Cuotas</label>
              <div class="relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-muted-foreground sm:text-sm">#</span>
                </div>
                <input type="number" formControlName="installments"
                  class="focus:ring-ring focus:border-ring block w-full pl-8 pr-12 sm:text-sm border-border rounded-lg py-2.5 transition-all duration-200"
                  placeholder="12">
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span class="text-muted-foreground sm:text-xs">pagos</span>
                </div>
              </div>
              <p *ngIf="termForm.get('installments')?.invalid && termForm.get('installments')?.touched"
                class="mt-1 text-xs text-destructive font-medium">
                Requerido (1-100)
              </p>
            </div>

            <!-- Order -->
            <div>
              <label class="block text-sm font-semibold text-foreground mb-2">Orden de Visualización</label>
              <div class="relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fas fa-sort-numeric-down text-muted-foreground text-xs"></i>
                </div>
                <input type="number" formControlName="order"
                  class="focus:ring-ring focus:border-ring block w-full pl-9 sm:text-sm border-border rounded-lg py-2.5 transition-all duration-200"
                  placeholder="1">
              </div>
            </div>
          </div>

          <!-- Frequency Selection (Cards) -->
          <div>
            <label class="block text-sm font-semibold text-foreground mb-3">Frecuencia de Pago</label>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

              <!-- Semanal -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-card hover:bg-accent/60"
                [class.selected]="termForm.get('frequency')?.value === 'semanal'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="semanal"
                    class="h-4 w-4 text-primary border-border focus:ring-ring">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-foreground">Semanal</span>
                  <span class="block text-xs text-muted-foreground mt-0.5">Pago cada 7 días</span>
                </div>
                <div class="ml-auto text-primary opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'semanal'">
                  <i class="fas fa-calendar-week text-xl"></i>
                </div>
              </label>

              <!-- Quincenal -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-card hover:bg-accent/60"
                [class.selected]="termForm.get('frequency')?.value === 'quincenal'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="quincenal"
                    class="h-4 w-4 text-primary border-border focus:ring-ring">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-foreground">Quincenal</span>
                  <span class="block text-xs text-muted-foreground mt-0.5">Pago cada 15 días</span>
                </div>
                <div class="ml-auto text-primary opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'quincenal'">
                  <i class="fas fa-calendar-alt text-xl"></i>
                </div>
              </label>

              <!-- Mensual -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-card hover:bg-accent/60"
                [class.selected]="termForm.get('frequency')?.value === 'mensual'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="mensual"
                    class="h-4 w-4 text-primary border-border focus:ring-ring">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-foreground">Mensual</span>
                  <span class="block text-xs text-muted-foreground mt-0.5">Pago cada 30 días</span>
                </div>
                <div class="ml-auto text-primary opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'mensual'">
                  <i class="fas fa-calendar text-xl"></i>
                </div>
              </label>

              <!-- Días Continuos -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-card hover:bg-accent/60"
                [class.selected]="termForm.get('frequency')?.value === 'dias_continuos'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="dias_continuos"
                    class="h-4 w-4 text-primary border-border focus:ring-ring">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-foreground">Personalizado</span>
                  <span class="block text-xs text-muted-foreground mt-0.5">Define los días exactos</span>
                </div>
                <div class="ml-auto text-primary opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'dias_continuos'">
                  <i class="fas fa-clock text-xl"></i>
                </div>
              </label>
            </div>
          </div>

          <!-- Frequency Days (Conditional with Animation) -->
          <div *ngIf="termForm.get('frequency')?.value === 'dias_continuos'"
            class="bg-primary/5 rounded-xl p-4 border border-primary/30 animate-fade-in-down">
            <label class="block text-sm font-semibold text-foreground mb-2">Intervalo de días</label>
            <div class="flex items-center">
              <input type="number" formControlName="frequencyDays"
                class="focus:ring-ring focus:border-ring block w-full sm:text-sm border-primary/30 rounded-lg py-2.5"
                placeholder="Ej: 45">
              <span class="ml-3 text-sm text-primary font-medium">días entre cada cuota</span>
            </div>
            <p class="mt-2 text-xs text-primary">
              <i class="fas fa-info-circle mr-1"></i>
              El cliente deberá realizar un pago cada X días exactos.
            </p>
          </div>

        </form>
      </div>

      <!-- Footer -->
      <div class="bg-muted/40 px-6 py-4 border-t border-border flex flex-row-reverse gap-3">
        <button type="button" (click)="saveTerm()" [disabled]="termForm.invalid"
          class="inline-flex justify-center rounded-lg border border-transparent shadow-sm px-6 py-2.5 bg-primary text-base font-medium text-primary-foreground hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed transition-all">
          Agregar Plazo
        </button>
        <button type="button" (click)="closeModal()"
          class="inline-flex justify-center rounded-lg border border-border shadow-sm px-6 py-2.5 bg-card text-base font-medium text-foreground hover:bg-accent/60 hover:text-foreground focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring transition-all">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>